import React, { memo } from 'react'
import InjurySimulator from '../component/InjurySimulation'

const LesaoRetina: React.FC = () => {
  return (
    <div style={{ position: 'relative' }}>
      <InjurySimulator />
    </div>
  )
}

export default memo(LesaoRetina)
